import * as $ from 'jquery';
import { MiscUtil } from './MiscUtil';

class DomUtil {
  public static CanCallPreventDefaultOnTouchEvent(domElement: HTMLElement): boolean {
    // If target is a checkbox, return false because checkboxes do not record the check/uncheck on
    // touchend if PreventDefault() is called. So when the target of an input event is a checkbox,
    // we must let mouse events fire in order for the check/uncheck to take effect.
    // Note: other inputs (input/textarea/select) seem unaffected by PreventDefault() being called.
    // Also, oddly, with mouse events, preventDefault() does not keep a checkbox from getting checked.
    if (DomUtil.IsCheckboxElement(domElement)) {
      return false;
    }

    // If target is a focusable text element, return false because we need to avoid calling PreventDefault()
    // in order to let them have focus when we click or tap on them.
    if (DomUtil.IsFocusableTextElement(domElement)) {
      return false;
    }

    // If we get to here, ok to call prevent default.
    return true;
  }

  /**
   * Returns true if domElement is a checkbox, else false.
   * @param {HTMLElement} domElement - the dom element
   * @returns whether or not we're dealing with a checkbawks
   */
  public static IsCheckboxElement(domElement: HTMLElement): boolean {
    if (!MiscUtil.IsNullOrUndefined(domElement) && !MiscUtil.IsNullOrUndefined(domElement.tagName)) {
      let targetTagName: string = domElement.tagName.toLowerCase();
      let typeAttributeValue: string = $(domElement).attr('type');
      if (targetTagName === 'input' && typeAttributeValue === 'checkbox') {
        return true;
      }
    }
    return false;
  }

  /**
   * Returns true if domElement is a focusable input element
   *  @param {HTMLElement} domElement - the dom element
   *  @returns true or false
   *  NOTE: DOM ELEMENT USED TO BE XMLELEMENT IN C#
   */
  public static IsFocusableTextElement(domElement: HTMLElement): boolean {
    if (!MiscUtil.IsNullOrUndefined(domElement) && !MiscUtil.IsNullOrUndefined(domElement.tagName)) {
      let targetTagName: string = domElement.tagName.toLowerCase();
      if ((targetTagName === 'textarea') || (targetTagName === 'input') || (targetTagName === 'select')) {
        return true;
      }
    }
    return false;
  }

  public static IsAncestorOf(ancestor: HTMLElement, child: HTMLElement): boolean {
    if (MiscUtil.IsNullOrUndefined(ancestor) || MiscUtil.IsNullOrUndefined(child)) {
      return false;
    }
    return $(child).parents().index(ancestor) >= 0;
  }
}

export { DomUtil };
